var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuvio1RuutuaikaEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3378,
    height: 2030,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3378,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3526,
    y: 2755,
    width: 3054,
    height: 1495
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3377,
    height: 2030
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-3300 -2444)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3300,
    y: 2444,
    width: 3378,
    height: 2030,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3527 4060.13 6577 4060.13M3527 3874.13 6577 3874.13M3527 3688.12 6577 3688.12M3527 3501.11 6577 3501.11M3527 3315.11 6577 3315.11M3527 3128.1 6577 3128.1M3527 2942.1 6577 2942.1M3527 2755 6577 2755",
    stroke: "#595959",
    strokeWidth: 2.29167,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3590.12 3256.11 3845.13 3256.11 3845.13 4247 3590.12 4247ZM3972.13 3200.1 4226.14 3200.1 4226.14 4247 3972.13 4247ZM4353.14 3310.11 4607.15 3310.11 4607.15 4247 4353.14 4247ZM4734.16 3388.11 4988.16 3388.11 4988.16 4247 4734.16 4247ZM5115.17 2955.1 5370.18 2955.1 5370.18 4247 5115.17 4247ZM5497.18 3254.11 5751.19 3254.11 5751.19 4247 5497.18 4247ZM5878.19 3330.11 6132.2 3330.11 6132.2 4247 5878.19 4247ZM6259.21 3290.11 6513.21 3290.11 6513.21 4247 6259.21 4247Z",
    fill: "#1A56EC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000360892 1492",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 3526.5 4247.5)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3526.5 4247.5 6577.5 4247.5",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3449.04 4265)"
  }, "0")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3418.45 4078)"
  }, "50")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3387.86 3892)"
  }, "100")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3387.86 3705)"
  }, "150")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3387.86 3519)"
  }, "200")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3387.86 3332)"
  }, "250")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3387.86 3146)"
  }, "300")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3387.86 2959)"
  }, "350")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3387.86 2773)"
  }, "400")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3687.04 4330)"
  }, "All")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 4045.37 4330)"
  }, "Men")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 4385.39 4330)"
  }, "Women")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 4784.92 4332)"
  }, "10")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 4846.11 4332)"
  }, "\u2013")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 4876.71 4332)"
  }, "14")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5166.19 4332)"
  }, "15")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5227.38 4332)"
  }, "\u2013")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5257.98 4332)"
  }, "24")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5547.46 4332)"
  }, "25")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5608.65 4332)"
  }, "\u2013")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5639.24 4332)"
  }, "44")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5928.73 4332)"
  }, "45")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 5989.92 4332)"
  }, "\u2013")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 6020.51 4332)"
  }, "64")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 6340.59 4332)"
  }, "65")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 6401.78 4332)"
  }, "\u2013")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3410 2688)"
  }, "min/day")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(1 0 0 1 3378.53 4418)"
  }, "Source: Statistics Finland, time use")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 64,
    transform: "matrix(1 0 0 1 3531.32 2585)"
  }, "Average daily screen time in 2020 to 2021")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuvio1RuutuaikaEn);
export default __webpack_public_path__ + "static/media/Kuvio 1 Ruutuaika EN.58cb56e9864f5cc69837098611af6170.svg";
export { ForwardRef as ReactComponent };